import SvgFilter from "@Components/CustomIcon/Filter"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { TouchableOpacity, View } from "react-native"
import { Searchbar } from "react-native-paper"
import styles from "./styles"
import { MaterialIcons } from "@expo/vector-icons"
import { TextInput } from "react-native-paper"

const CustomSearchBar = (props) => {
    const { setSearchQuery, searchQuery, toggleModal, showFilter } = props
    const onChangeSearch = (query) => setSearchQuery(query)

    return (
        <View style={styles.container}>
            <Searchbar
                style={{ ...styles.searchBar, flex: showFilter ? 0.95 : 1 }}
                placeholder="Rechercher"
                placeholderTextColor={baseColors.green.primary}
                onChangeText={onChangeSearch}
                value={searchQuery}
                iconColor={baseColors.green.primary}
                icon={() => <MaterialIcons name="search" size={26} color={baseColors.green.primary} />}
                right={() => (
                    <MaterialIcons
                        style={{ paddingRight: 20 }}
                        name="close"
                        size={20}
                        color={baseColors.green.primary}
                        onPress={() => setSearchQuery("")}
                    />
                )}
                theme={{
                    colors: {
                        text: baseColors.green.primary,
                        primary: baseColors.green.primary
                    }
                }}
            />
            {showFilter && (
                <TouchableOpacity onPress={toggleModal}>
                    <SvgFilter />
                </TouchableOpacity>
            )}
        </View>
    )
}

export default CustomSearchBar
